<template>
    <div>
        <!--    <img src="./print.svg" alt="" style="width: 100%;">-->
        <section>
            <div class="searchBox">
                <div></div>
                <div>
                    <el-input
                        class="searchInput"
                        size="small"
                        v-model="productName"
                        @keyup.native="changeProductInfo"
                        placeholder="输入关键字"
                        suffix-icon="el-icon-search">
                    </el-input>
                </div>
            </div>
             <div v-if="productList.length==0" style="text-align:center;margin-bottom:20px" >
                    <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
            </div>
            <el-row :gutter="30" style="display: flex;flex-wrap: wrap;width:73%" v-if="productList.length!=0">
                <el-col :span="8" v-for="(items, index) in productList" :key="index">
                    <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
                        <!-- <img
                            class="image"
                            :src="items.urlList[0].urlPath"
                            fit="fill"> -->
                        <el-carousel height="150px">
                          <el-carousel-item v-for="(url,urlIndex) in items.urlList" :key="urlIndex">
                            <el-image 
                              class="image"
                              :src="url.urlPath" 
                              :preview-src-list="srcList">
                            </el-image>
                          </el-carousel-item>
                        </el-carousel>

                        <div style="padding: 15px">
                            <h4 class="mpTitle">{{ items.productName }}</h4>
                            <p class="mpTime">{{ items.createDate }}</p>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <div style="text-align: right">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total" class="pagination">
                </el-pagination>
            </div>
        </section>
    </div>
</template>

<script>
    import {getPresentationList} from '../../utils/interface';
    
    export default {
        //   成果展示
        name: "printResults",
        components: {},
        data() {
            return {
                uuid: '',
                enterPriseId: '',
                current: 1,
                total: 0,
                pageSize: 6,
                productName: '',
                productList: [],
                srcList: []
            };
        },
        created() {
            this.uuid = this.$route.params.uuid;
            this.enterPriseId = this.$route.params.enterPriseId;
            this.getPresentationList();
        },
        methods: {
            changeProductInfo() {
                this.current = 1;
                this.getPresentationList();
            },
            getPresentationList() {
                let params = {
                    productName: this.productName,
                    current: this.current,
                    pageSize: this.pageSize,
                    enterPriseId: this.enterPriseId
                };
                getPresentationList(params).then((res) => {
                    this.productList = res.list;
                    this.total = res.total;
                    this.pageSize = res.size;
                    this.current = res.current;
                    res.list.forEach(imgs => {
                      imgs.urlList.forEach(imgUrl => {
                        console.log('imgs.urlList',imgUrl.urlPath )
                        this.srcList.push(imgUrl.urlPath)
                      })
                    });
                });
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
				window.scrollTo(0,0);
                this.getPresentationList()
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        width: 1200px;
        margin: 0 auto;
    }
    
    .leftCont {
        margin-top: 30px;
        
        .leftCard {
            margin-bottom: 30px;
            border: none;
            
            /deep/ .el-card__header {
                color: #157EFB;
                background-color: #F3F3F3;
                font-size: 18px;
                padding: 12px 20px;
            }
            
            /deep/ .el-card__body {
                background-color: #fbfbfb;
            }
        }
        
        .servInfo h3 {
            font-size: 16px;
            font-weight: normal;
            margin-bottom: 15px;
        }
        
        .servInfo .eval li {
            font-size: 14px;
            margin-bottom: 10px;
            display: flex;
        }
        
        .servInfo .eval li span {
            margin-right: 30px;
        }
        
        .servInfo .contact {
            margin-top: 30px;
            margin-bottom: -10px;
            font-size: 12px;
        }
        
        .servInfo .contact i {
            margin-right: 5px;
        }
        
        .servInfo .contact p {
            font-size: 14px;
            margin-bottom: 10px;
        }
    }
    
    .printTitle {
        font-size: 24px;
        font-weight: normal;
        color: #157EFB;
        margin-top: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #e3e3e3;
        padding-bottom: 10px;
        
        span.tit {
            padding-bottom: 10px;
            border-bottom: 1px solid #157EFB;
        }
        
        span.more {
            font-size: 16px;
            float: right;
            margin-top: 10px;
        }
        
        .more i {
            color: #505050 !important;
        }
    }
    
    .hotSell {
        margin-bottom: -30px;
        
        li {
            margin-bottom: 30px;
        }
        
        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }
        
        .topServBoxInfo p {
            font-size: 12px;
            color: #aaa;
        }
    }
    
    .relateServ {
        margin-bottom: -30px;
        
        li {
            margin-bottom: 30px;
        }
        
        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }
    }
    
    .topServBox {
        background-color: #fff;
        height: 200px;
        border-radius: 8px;
        box-shadow: 0 1px 5px #eaeaea;
        margin-top: -100px;
        padding: 30px;
        box-sizing: border-box;
        
        .topServBoxInfo h3 {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: normal;
        }
        
        .topServBoxInfo p {
            font-size: 12px;
            color: #585858;
        }
        
        /deep/ .el-menu.el-menu--horizontal {
            border-color: transparent;
        }
        
        /deep/ .el-menu--horizontal > .el-menu-item.is-active {
            border: none !important;
            background-color: #F3F8FF;
            border-radius: 5px;
        }
        
        /deep/ .el-menu--horizontal > .el-menu-item {
            height: 30px;
            line-height: 26px;
        }
    }
    
    .topServBoxNum {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        
        p:first-child {
            font-size: 16px;
        }
        
        p:last-child {
            font-size: 12px;
            color: #585858;
        }
    }
    
    .menu-sub {
        margin-top: 35px;
        font-size: 16px;
    }
    
    .box-card {
        margin-bottom: 30px;
        position: relative;
        
        .image {
            width: 100%;
            height: 150px;
            display: block;
        }
    }
    
    .searchBox {
        background-color: #FAFCFF;
        height: 50px;
        line-height: 50px;
        margin: 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        
        .searchInput /deep/ .el-input__inner {
            border-radius: 30px;
        }
        
        /deep/ .el-form-item {
            margin-bottom: 0;
        }
        
        /deep/ .el-form-item__label {
            line-height: inherit;
        }
        
        /deep/ .el-form-item__content {
            line-height: inherit;
        }
    }
    
    .mpBox {
        display: flex;
        align-items: center;
    }
    
    .mpCheck {
        position: absolute;
        right: 20px;
        top: 20px;
    }
    
    .mpTitle {
        font-size: 14px;
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    
    .mpComp {
        margin-top: 10px;
        font-size: 13px;
        color: #000000;
    }
    
    .mpPrice {
        margin: 10px 0;
        font-size: 13px;
        color: #DA251D;
        
        span {
            color: #000;
            margin-left: 10px;
        }
    }
    
    .mpDetail {
        margin-top: 10px;
        
        dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: normal;
            line-height: 22px !important;
        }
        
        dd {
            font-size: 13px;
            line-height: 22px !important;
            margin-left: 70px;
            margin-bottom: 6px;
            color: #808080;
        }
    }
    
    .mpFooter-v1 {
        text-align: center;
        font-size: 14px;
        background: #F1F5FE;
        border: 1px solid #EBEEF5;
        margin: -10px -21px -21px;
        height: 50px;
        line-height: 50px;
    }
    
    .mpFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        border-top: 1px solid #E3E3E3;
        margin: 0 0 -15px;
        position: relative;
        
        span {
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            line-height: 50px;
        }
        
        span a {
            font-size: 12px;
            color: #808080;
        }
        
        span a:hover {
            color: rgba(21, 126, 251, 0.80);
        }
        
        :after {
            position: absolute;
            content: '';
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
        }
    }
    
    .printBox {
        /deep/ .el-input--suffix .el-input__inner {
            padding: 0 15px;
        }
    }
    
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    
    .clearfix:after {
        clear: both
    }
    
    a {
        color: #157EFB;
    }
    
    a:hover {
        color: rgba(21, 126, 251, 0.80);
    }
    
    .mpTime {
        font-size: 12px;
        color: #aaa;
        margin-top: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/print/printResults.vue